import { render, staticRenderFns } from "./AlertaComponente.vue?vue&type=template&id=8db55216"
import script from "./AlertaComponente.vue?vue&type=script&lang=js"
export * from "./AlertaComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports